import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { initSentry } from '@client/sentry';
import { App } from '@ui/App';
import '@ui/styles/index.css';

// Sentry must init before React renders so it can capture render-phase errors.
initSentry();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
